@if (!podeVer) {
  <app-no-access></app-no-access>
} @else {
<div class="container-fluid">
  <app-page-header-with-button
    title="Projetos"
    icon="fas fa-project-diagram"
    subtitle="Gerencie os projetos do sistema"
    buttonText="Novo Projeto"
    buttonIcon="fas fa-plus"
    (buttonClick)="novoProjeto()">
  </app-page-header-with-button>

  <!-- Filtros -->
  <div class="card mb-4">
    <div class="card-header">
      <h5 class="card-title mb-0">
        <i class="fas fa-filter me-2"></i>
        Filtros
      </h5>
    </div>
    <div class="card-body">
      <form [formGroup]="filtroForm">
        <div class="row">
          <div class="col-md-3">
            <label for="Descricao" class="form-label">Descrição</label>
            <input type="text" class="form-control form-control-sm" id="Descricao" formControlName="Descricao"
              placeholder="Buscar por descrição...">
          </div>
          <div class="col-md-3">
            <label for="Cliente" class="form-label">Cliente</label>
            <input type="text" class="form-control form-control-sm" id="Cliente" formControlName="Cliente"
              placeholder="Buscar por cliente...">
          </div>
          <div class="col-md-2">
            <label for="Feira" class="form-label">Feira</label>
            <input type="text" class="form-control form-control-sm" id="Feira" formControlName="Feira"
              placeholder="Buscar por feira...">
          </div>
          <div class="col-md-2">
            <label for="Status" class="form-label">Status</label>
            <select class="form-select form-select-sm" id="Status" formControlName="Status">
              <option [ngValue]="null">Todos os status</option>
              <option [ngValue]="0">Iniciado</option>
              <option [ngValue]="1">Aprovado</option>
              <option [ngValue]="2">Recusado</option>
              <option [ngValue]="3">Em Negociação</option>
              <option [ngValue]="4">Finalizado</option>
            </select>
          </div>
          <div class="col-md-2">
            <label for="QuantidadePorPagina" class="form-label">Itens por página</label>
            <select class="form-select form-select-sm" id="QuantidadePorPagina" formControlName="QuantidadePorPagina"
              (change)="onQuantidadePorPaginaChange()">
              <option [ngValue]="5">5</option>
              <option [ngValue]="10">10</option>
              <option [ngValue]="25">25</option>
              <option [ngValue]="50">50</option>
            </select>
          </div>
          <div class="col-md-2 d-flex align-items-end">
            <button type="button" class="btn btn-outline-secondary btn-sm w-100 mt-2" (click)="limparFiltros()">
              <i class="fas fa-eraser me-1"></i>
              Limpar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>

    <!-- Mensagem de erro -->
    <div *ngIf="error && !isLoading" class="alert alert-danger" role="alert">
      <i class="fas fa-exclamation-triangle me-2"></i>
      {{ error }}
    </div>

    <!-- Loading -->
    <div *ngIf="isLoading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Carregando...</span>
      </div>
      <p class="mt-2 text-muted">Carregando projetos...</p>
    </div>

    <!-- Lista de Projetos -->
    <div *ngIf="!isLoading" class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h5 class="card-title mb-0">
        <i class="fas fa-list me-2"></i>
        Projetos ({{ pagination.totalDeItens }})
      </h5>
    </div>
    <div class="card-body p-0">
      <div *ngIf="projetos.length === 0" class="text-center py-5">
        <i class="fas fa-project-diagram fa-3x text-muted mb-3"></i>
        <h5 class="text-muted">Nenhum projeto encontrado</h5>
        <p class="text-muted">Clique em "Novo Projeto" para criar o primeiro projeto.</p>
      </div>

      <div *ngIf="projetos.length > 0" class="table-responsive">
        <table class="table table-hover table-striped mb-0">
          <thead class="table-light">
            <tr>
              <th class="px-3 py-2 text-center actions-column">Ações</th>
              <th class="px-3 py-2">Descrição</th>
              <th class="px-3 py-2">Cliente</th>
              <th class="px-3 py-2">Feira</th>
              <th class="px-3 py-2 text-center">Status</th>
              <th class="px-3 py-2">Data Cadastro</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let projeto of projetos">
              <td class="text-center actions-column">
                @if (!podeEditar) {
                  <span class="text-muted" title="Sem permissão para editar">
                    <i class="bx bx-block"></i>
                  </span>
                } @else {
                  <div class="dropdown" ngbDropdown>
                    <button class="btn btn-link font-size-16 shadow-none py-0 text-muted dropdown-toggle" type="button"
                      ngbDropdownToggle aria-expanded="false">
                      <i class="bx bx-dots-horizontal-rounded"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-start" ngbDropdownMenu>
                      <li>
                        <button (click)="editarProjeto(projeto)" title="Editar Projeto" type="button"
                          class="dropdown-item">
                          <i class="fas fa-edit me-2"></i>
                          Editar Projeto
                        </button>
                        <button (click)="onClickCliente(projeto)" title="Visualizar Projetos" type="button"
                          class="dropdown-item" [disabled]="!projeto.clienteId">
                          Visualizar Projetos
                        </button>
                        <button [routerLink]="['/clientes', projeto.clienteId]" class="dropdown-item">
                          Ver Cliente
                        </button>
                        <!-- <button (click)="modalAtualizarStatus(projeto)" 
                                class="dropdown-item" 
                                [disabled]="!podeAtualizarStatus(projeto.statusProjeto && projeto.statusProjeto.statusProjeto)"
                                [class.disabled]="!podeAtualizarStatus(projeto.statusProjeto && projeto.statusProjeto.statusProjeto)">
                          Atualizar Status
                        </button> -->
                      </li>
                    </ul>
                  </div>
                }
              </td>
              <td class="px-3 py-2">
                <strong>{{ projeto.descricao }}</strong>
              </td>
              <td class="px-3 py-2">
                {{ projeto.cliente || '-' }}
              </td>
              <td class="px-3 py-2">
                <div>
                  <strong>{{ projeto.feira || '-' }}</strong>
                </div>
                <div *ngIf="projeto.comprimento || projeto.largura" class="small text-muted">
                  <span *ngIf="projeto.comprimento">C: {{ formatarMedida(projeto.comprimento) }}m</span>
                  <span *ngIf="projeto.comprimento && projeto.largura"> | </span>
                  <span *ngIf="projeto.largura">L: {{ formatarMedida(projeto.largura) }}m</span>
                </div>
              </td>
              <td class="px-3 py-2 text-center">
                <span [class]="getStatusClass(projeto.statusProjeto && projeto.statusProjeto.statusProjeto)">
                  {{ getStatusText(projeto.statusProjeto && projeto.statusProjeto.statusProjeto) }}
                </span>
              </td>
              <td class="px-3 py-2">
                {{ projeto.dataCadastro | date:'dd/MM/yyyy' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Paginação -->
    <div *ngIf="!isLoading && pagination.totalDeItens > 0" class="card-footer">
      <div class="row">
        <div class="col-sm-12 col-md-5">
          <div class="dataTables_info" role="status" aria-live="polite">
            <span *ngIf="pagination.totalDeItens > 0">
              Mostrando {{ (pagination.paginaAtual - 1) * pagination.quantidadePorPagina + 1 }} até
              {{ (pagination.paginaAtual * pagination.quantidadePorPagina) > pagination.totalDeItens ?
              pagination.totalDeItens : (pagination.paginaAtual * pagination.quantidadePorPagina) }} de
              {{ pagination.totalDeItens }} registros
            </span>
            <span *ngIf="pagination.totalDeItens === 0">
              Nenhum registro encontrado
            </span>
          </div>
        </div>
        <div class="col-sm-12 col-md-7">
          <div class="dataTables_paginate paging_simple_numbers d-flex justify-content-end">
            <ngb-pagination [(page)]="pagination.paginaAtual" [pageSize]="pagination.quantidadePorPagina"
              [collectionSize]="pagination.totalDeItens" [maxSize]="5" [rotate]="true" [boundaryLinks]="true"
              (pageChange)="onPageChange($event)" class="pagination-rounded">
            </ngb-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}